import { io } from 'socket.io-client';
import { SocketServerBaseURL } from '../../socketio-config';

const state = {
  socket: null,
  connecting: false,
  targetGroupID: null
};

const mutations = {
  setTargetGroupID(state, id) { state.targetGroupID = id; },
  setConnecting(state, val) {
    state.connecting = val;
  },
  setActiveSocket(state, socket) {
    state.socket = socket;
  },
};

const actions = {
  initializeSocket(
    {
      commit, dispatch,
      getters: { targetSocketGroupID },
      rootGetters: { socket, hasAuthToken, authToken, isConnecting }
    }
  ) {
    if (socket) return;
    if (isConnecting) return;

    if (!hasAuthToken) {
      console.error('Failed to connect to socket io - has no auth token');
      return;
    }

    commit('setConnecting', true);

    return new Promise((resolve, reject) => {
      // sock == new socket, socket == global socket
      const sock = io(SocketServerBaseURL, { auth: { token: authToken }, transports: ['websocket'] });
      sock.on('connect', () => {
        commit('setActiveSocket', sock);
        sock.emit('join', { group: targetSocketGroupID });
        resolve(sock);
        commit('setConnecting', false);
      });

      sock.on('connect_error', (err) => {
        console.error(err);
        reject(err);
      });

      sock.on('poll', () => {
        // alert('dispatching pollGroup');
        dispatch('pollGroup');
      });

      sock.on('saveStateRestored', () => {
        window.location.reload(true);
      });

      sock.on('disconnect', () => {
        commit('setConnecting', true);
        // TODO: Handle this?  Might not actually need to do anything since
        // socket.io handles reconnects automatically.
      });
    });
  },
  destroySocket({ commit, getters: { socket } }) {
    // TODO
    if (!socket) return;
    socket.disconnect();
    commit('setActiveSocket', null);
  }
};

const getters = {
  socket({ socket }) { return socket; },
  isConnecting({ connecting }) { return connecting; },
  targetSocketGroupID({ targetGroupID }) { return targetGroupID; },
};

export default {
  state,
  mutations,
  actions,
  getters
};




// WEBPACK FOOTER //
// ./src/store/game/socketio.js